// Professional HTML template generation for drawer widget
// This is server-side only - generates HTML based on configuration

export function generateDrawerHTML(drawerConfig) {
  const {
    title = 'Scan to continue on your phone',
    tabText = 'Connect Now',
    showLogo = true
  } = drawerConfig;

  // Escape HTML to prevent XSS
  const escapeHtml = (text) => {
    return text.replace(/[<>&"']/g, (m) => {
      return {
        '<': '&lt;',
        '>': '&gt;',
        '&': '&amp;',
        '"': '&quot;',
        "'": '&#39;'
      }[m];
    });
  };

  return `
<div class="pp-drawer" id="ppDrawer">
  <button class="pp-drawer-close" id="ppDrawerClose" aria-label="Close drawer">×</button>
  <h3>${escapeHtml(title)}</h3>
  <div class="pp-qr-card">
    <div id="ppQrContainer">
      <!-- QR code will be inserted here -->
    </div>
  </div>
</div>
<div class="pp-drawer-tab" id="ppDrawerTab">
  ${showLogo ? '<img src="https://storage.googleapis.com/liquidqr-9b192.appspot.com/pp_qr/LiquidQRLogo.png" alt="LiquidQR" class="pp-tab-logo" onerror="this.style.display=\'none\'">' : ''}
  <span class="pp-tab-text">${escapeHtml(tabText)}</span>
</div>
`.trim();
}
